import React from 'react'
import axios from 'axios'
import qs from 'qs'
import {
    FormCell, CellHeader, Label, CellBody, Input,
    CellFooter, Button, Dialog, Toast, Toptips
} from 'react-weui'
import { browserHistory } from 'react-router'
import { Page } from '../components'
import Header from '../components/liveroomLecturer/Header'
import { WKVisible } from '../components/wk'
import { isLZWKAPP, isQQ, isAlipay } from '../utils'
import { goBack } from '../utils/connectApp'
import '../css/page/PhoneEditPage.css'


class PhoneEditPage extends React.Component {
    constructor (props) {
        super(props)
        // 获取验证码的时间间隔s
        this.COUNT_DOWN = 60
        this.type = props.location.query.type
        this.isSending = false
        this.state = {
            init:false,
            contact: '',
            captcha: '',
            second: this.COUNT_DOWN,
            isSubmitting: false,
            countryCode: '+86',
            isAppealShow: false,
            alertDialog: {
                isShow: false,
                text: '',
            },
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
            isBindPhone: false,
        }
    }
    componentDidMount () {
        //document.title = '短信验证'
        /*app里跳转特殊处理*/
        location.assign('/management/bind-cell-phone?change=change&fr=app')
        //this.fetchProfile()
    }
    fetchProfile () {
        this.setState({ isSubmitting: true })
        axios.get('/api/account/personal')
            .then(res => {
                const accountRes = res.data.data.account
                this.setState({
                    contact: accountRes.telephone,
                    isSubmitting: false,
                    isBindPhone: !!accountRes.telephone,
                })
            })
    }
    componentWillUnmount () {
        clearInterval(this.timer)
    }
    bindValue (e, field) {
        this.setState({ [field]: e.target.value })
    }
    handleClickSendBtn () {
        if (this.state.second < this.COUNT_DOWN) {
            return
        }
        const { contact, countryCode } = this.state
        if (isLZWKAPP()) {
            if (countryCode.trim() === '') {
                return this.showTip('请填写国家代码')
            }
        }
        if (contact.toString().length !== 11 || !+contact) {
            return this.showTip('请填写正确的11位数字手机号码')
        } else {
            this.postSendCaptcha()
        }
    }
    isAlipayOrQq () {
        return isQQ()
    }
    postSendCaptcha () {
        if (this.isSending) {
            return
        }
        this.isSending = true
        return axios.post('/api/account/telephone/send_bind_sms', qs.stringify({
            phone_number: this.state.contact,
        }))
            .then(res => {
                this.isSending = false
                if (res.data.code !== 0) {
                    if (res.data.msg.trim() === '该手机号已绑定其他账号') {
                        this.setState({isAppealShow: true})
                        setTimeout(() => {
                            this.setState({isAppealShow: false})
                        }, 2000)
                    } else {
                        this.showTip(res.data.msg)
                    }
                    return
                }
                this.setState({
                    second: this.state.second - 1,
                })
                this.timer = setInterval(() => {
                    if (this.state.second <= 1) {
                        this.setState({ second: this.COUNT_DOWN })
                        clearInterval(this.timer)
                        return
                    }
                    this.setState({ second: this.state.second - 1 })
                }, 1000)
                this.showTip('验证码已发送，请查看手机短信', 'primary')
            })
            .catch(err => {
                this.isSending = false
            })
    }
    postModifyContact () {
        this.setState({ isSubmitting: true })
        const postParams = isLZWKAPP() ? { webview: 1 } : {}
        return axios.post('/api/account/telephone/bind', qs.stringify({
            phone_number: this.state.contact,
            sms_code: this.state.captcha,
            zone: isLZWKAPP() ? this.state.countryCode.replace('+', '') : '',
        }), {
            params: postParams
        })
            .then(res => {
                this.setState({ isSubmitting: false })
                if (res.data.code !== 0) {
                    this.showTip(res.data.msg)
                    return
                }
                if (this.isAlipayOrQq()) {
                    return this.toApp()
                }
                if (this.type === 'liveroom-create') {
                    location.assign('/liveroom/create')
                } else {
                    this.setState({
                        alertDialog: { isShow: true, text: '修改成功' },
                    })
                }
            })
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    onSubmit () {
        if (this.state.contact.toString().length !== 11 || !+this.state.contact) {
            this.showTip('请填写正确的11位数字手机号码')
            return
        }
        if (this.state.captcha === '') {
            this.showTip('请填写验证码')
            return
        }
        if (isLZWKAPP()) {
            if (this.state.countryCode.trim() === '') {
                this.showTip('请填写国家代码')
                return
            }
        }
        this.postModifyContact()
    }
    onClickDialogOk () {
        // APP就停留本页
        this.setState({
            alertDialog: { isShow: false },
        })
        if (!isLZWKAPP()) {
            browserHistory.go(-1)
        } else {
            goBack()
        }
    }
    getIsDisabled () {
        if (this.isAlipayOrQq() && this.state.isBindPhone) {
            return false
        }
        return !(this.state.contact && this.state.captcha)
    }
    isShowCaptchaCell () {
        if (this.isAlipayOrQq()) {
            if (!this.state.isBindPhone) {
                return true
            }
        } else {
            return true
        }
        return false
    }
    aToLocation (url) {
        const goToApp = document.createElement('A')
        goToApp.href = url
        goToApp.id = 'goToApp'
        document.body.appendChild(goToApp)
        document.querySelector('#goToApp').click()
    }
    toApp () {
        this.aToLocation('https://a.app.qq.com/o/simple.jsp?pkgname=com.lizhiweike')
    }
    onClickToApp () {
        if (this.state.isBindPhone) {
            this.toApp()
        } else {
            this.onSubmit()
        }
    }
    render() {
        if(!this.state.init) return null
        return (
            <Page>
                <div className="wk-inner-page phone-edit-page">
                    <Header title={this.isAlipayOrQq() ? '绑定手机即可在APP上登录' : '根据国家法律法规，请先进行手机认证'} />
                    <div className='panel'>
                        <div style={{height: '40px', marginBottom: '10px'}}>
                            <FormCell className="cell-box__input basic-border" vcode={this.isShowCaptchaCell()}>
                                <CellHeader className='label-wrap'>
                                    <Label>手机号码</Label>
                                </CellHeader>
                                {
                                    isLZWKAPP() && (
                                        <CellHeader className='country-code'>
                                            <Input
                                                value={this.state.countryCode}
                                                // onChange={e => this.bindValue(e, 'countryCode')}
                                                type="tel"
                                                disabled
                                            />
                                        </CellHeader>
                                    )
                                }
                                <CellBody className='phone'>
                                    <Input
                                        value={this.state.contact}
                                        onChange={e => this.bindValue(e, 'contact')}
                                        type="tel"
                                        placeholder="请输入手机号码"
                                    />
                                </CellBody>
                            </FormCell>
                        </div>
                        <div style={{height: '40px'}}>
                            {
                                this.isShowCaptchaCell() && (
                                    <FormCell className="cell-box__input basic-border">
                                        <CellHeader className='label-wrap'>
                                            <Label>验证码</Label>
                                        </CellHeader>
                                        <CellBody className='captcha'>
                                            <Input
                                                value={this.state.captcha}
                                                onChange={e => this.bindValue(e, 'captcha')}
                                                type="number"
                                                pattern='[0-9]*'
                                                placeholder="请输入获取的验证码"
                                            />
                                        </CellBody>
                                        <CellFooter>
                                            <Button
                                                onClick={e => this.handleClickSendBtn()}
                                                type="vcode"
                                                disabled={this.state.second < this.COUNT_DOWN}
                                            >
                                            <span className='normal-font'>
                                                {this.state.second < this.COUNT_DOWN ? `${this.state.second}s后重新获取` : '获取验证码'}
                                            </span>
                                                <span className="vcode-btn-line"/>
                                            </Button>
                                        </CellFooter>
                                    </FormCell>
                                )
                            }
                        </div>
                    </div>
                    <div className="wk-btn-90" style={{padding: "0 20px"}}>
                        <WKVisible create={this.isAlipayOrQq()}>
                            <Button type='primary' onClick={e => this.onClickToApp()} disabled={this.getIsDisabled()}>
                                用手机号登录APP
                            </Button>
                        </WKVisible>
                        <WKVisible create={!this.isAlipayOrQq()}>
                            <Button type='primary' onClick={e => this.onSubmit()} disabled={this.getIsDisabled()}>
                                {this.type === 'liveroom-create' ? '下一步' : '提交'}
                            </Button>
                        </WKVisible>
                    </div>
                    <a className="liveroom-qa" href="/specials/feedback">无法收到验证码？</a>
                    {/* 成功dialog  */}
                    <Dialog type="ios" title='' buttons={[
                        { type: 'primary', label: '确定', onClick: () => this.onClickDialogOk() },
                    ]} show={this.state.alertDialog.isShow}>
                        {this.state.alertDialog.text}
                    </Dialog>
                    {/* loading toast  */}
                    <Toast icon="loading" show={this.state.isSubmitting}></Toast>
                    <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
                    <Toptips type='warn' show={this.state.isAppealShow}>
                        <div>
                            该手机号已绑定其他账号，<a className="edit-appeal" href="/specials/feedback?fr=appeal">点此申诉 ></a>
                        </div>
                    </Toptips>
                </div>
            </Page>
        )
    }
}


export default PhoneEditPage



// WEBPACK FOOTER //
// ./src/pages/PhoneEditPage.js